
export const generateWhatsAppReport = (date, className, studentsData) => {
  const totalStudents = studentsData.length;
  const raw = (s) => String(s.status || '').trim();
  const isLeave = (s) => raw(s).toLowerCase() === 'leave' || raw(s).toUpperCase() === 'L';
  const isAbsent = (s) => raw(s).toLowerCase() === 'absent' || raw(s).toUpperCase() === 'A';
  // 'late' students are physically present, so they stay in the present group
  const isPresent = (s) => ['present', 'late'].includes(raw(s).toLowerCase()) || raw(s).toUpperCase() === 'P';

  const presentStudents = studentsData.filter(isPresent);
  const absentStudents = studentsData.filter(isAbsent);
  const leaveStudents = studentsData.filter(isLeave);
  const presentCount = presentStudents.length;
  const absentCount = absentStudents.length;
  const leaveCount = leaveStudents.length;

  const homeworkPendingStudents = presentStudents.filter(s => s.homework?.isDone === false && s.homework?.pendingSubjects?.length > 0);

  const numbered = (list) => list.map((s, i) => `${i + 1}. ${s.name}`).join('\n');
  const hwPendingList = homeworkPendingStudents.map((s, i) => `${i + 1}. ${s.name} — ${s.homework.pendingSubjects.join(', ')}`).join('\n');

  // DD-MM-YYYY (accepts YYYY-MM-DD strings or Date-parsable values)
  const formattedDate = /^\d{4}-\d{2}-\d{2}/.test(String(date))
    ? String(date).slice(0, 10).split('-').reverse().join('-')
    : new Date(date).toLocaleDateString('en-GB').replace(/\//g, '-');

  const blocks = [
    `📋 *Attendance Report*\n📅 Date: ${formattedDate}\n✅ *Total Present:* ${presentCount}\n❌ *Total Absent:* ${absentCount}\n🟡 *Total Leave:* ${leaveCount}`
  ];

  if (absentCount > 0) blocks.push(`🔴 *Absent Students:*\n${numbered(absentStudents)}`);
  else if (leaveCount > 0) blocks.push('🔴 *Absent Students:* None');
  else blocks.push('✨ 100% Attendance Today!');

  if (leaveCount > 0) blocks.push(`🟡 *Approved Leave:*\n${numbered(leaveStudents)}`);

  if (homeworkPendingStudents.length > 0) {
    blocks.push(`📚 *Pending Homework:*\n${hwPendingList}`);
  }

  return blocks.join('\n\n');
};
